import React, {Component} from 'react';
import Wrapper from '../user-form/Wrapper';
class HomePage extends Component {
    render() {
        return (
            <div className="address-form-outer">
                <Wrapper />
            </div>
        );
    }

}   
export default HomePage;